import i18n from "./i18n";

const basePath = `/api${process.env.REACT_APP_BACKEND_API_PATH}`;
const basePathNoAuth = `/api${process.env.REACT_APP_BACKEND_PUBLIC_API_PATH}`;

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const complementaryUrl = process.env.REACT_APP_COMPLEMENTARY_URL;

const resolveBaseUrl = path => backendUrl
    ? `${backendUrl}${path}`
    : window.location.origin + path;

const resolveBackendUrl = path => window.location.origin.startsWith(complementaryUrl)
    ? `${complementaryUrl}${path}`
    : resolveBaseUrl(path);

const isComplementaryOrigin = () => !!complementaryUrl &&  window.location.origin.startsWith(complementaryUrl);
const getComplementaryUrl = () => complementaryUrl;

const baseUrl= resolveBackendUrl(basePath);
const baseUrlNoAuth= resolveBackendUrl(basePathNoAuth);

const getOptions = (baseUrl, endPoint = "", parameters = {}) => {
  return {
    url: `${baseUrl}${endPoint}?` + new URLSearchParams({...parameters, lang:i18n.language}).toString(),
    method: "GET",
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("kc_tok"))
          ? JSON.parse(sessionStorage.getItem("kc_tok")).token
          : ""
      }`,
    },
  };
};

const getOptionsForAction = (baseUrl, endPoint = "", parameters = {}) => {
  let options = {
    url: `${baseUrl}${endPoint}?` + new URLSearchParams(parameters).toString(),
    method: "GET",
  };
  let action = JSON.parse(sessionStorage.getItem("kc_action"))
  if (action) {
    options = {
      ...options,
      headers: {
        Authorization: `Bearer ${action.token}`,
      },
    }
  }
  return options;
};

const patchOptionsForAction = (baseUrl, endPoint = "", data = {}) => {
  return {
    url: `${baseUrl}${endPoint}`,
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${
          JSON.parse(sessionStorage.getItem("kc_action"))
              ? JSON.parse(sessionStorage.getItem("kc_action")).token
              : ""
      }`,
    },
    data: data,
  };
};

const getOptionsNoAuth = (baseUrl, endPoint = "", parameters = {}) => {
  return {
    url: `${baseUrl}${endPoint}?` + new URLSearchParams({...parameters, lang: i18n.language}).toString(),
    method: "GET",
    headers: {},
  };
};

const putOptions = (baseUrl, endPoint = "", data = {}) => {

  return {
    url: `${baseUrl}${endPoint}?` + new URLSearchParams({lang:i18n.language}).toString(),
    method: "PUT",
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("kc_tok"))
          ? JSON.parse(sessionStorage.getItem("kc_tok")).token
          : ""
      }`,
    },
    data: data,
  };
};

const postOptions = (baseUrl, endPoint = "", data = {}) => {
  return {
    url: `${baseUrl}${endPoint}?` + new URLSearchParams({lang:i18n.language}).toString(),
    method: "POST",
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("kc_tok"))
          ? JSON.parse(sessionStorage.getItem("kc_tok")).token
          : JSON.parse(sessionStorage.getItem("kc_action")).token
      }`,
    },
    data: data,
  };
};

const deleteOptions = (baseUrl, endPoint = "", data = {}) => {
  return {
    url: `${baseUrl}${endPoint}?` + new URLSearchParams({lang:i18n.language}).toString(),
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("kc_tok"))
          ? JSON.parse(sessionStorage.getItem("kc_tok")).token
          : JSON.parse(sessionStorage.getItem("kc_action")).token
      }`,
    },
    data: data,
  };
};

const patchOptions = (baseUrl, endPoint = "", data = {}) => {
  return {
    url: `${baseUrl}${endPoint}`,
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("kc_tok"))
          ? JSON.parse(sessionStorage.getItem("kc_tok")).token
          : ""
      }`,
    },
    data: data,
  };
};

const otpPostOptions = (baseUrl, endPoint = "", data = {},token) => {
  return {
    url: `${baseUrl}${endPoint}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("kc_tok"))
          ? JSON.parse(sessionStorage.getItem("kc_tok")).token
          : JSON.parse(sessionStorage.getItem("kc_action")).token
      }`,
      "Accept-Ticket":`Flow ${token}`
    },
    data: data,
  };
};

export {
  baseUrl,
  baseUrlNoAuth,
  isComplementaryOrigin,
  getComplementaryUrl,
  getOptions,
  putOptions,
  postOptions,
  getOptionsNoAuth,
  deleteOptions,
  patchOptions,
  getOptionsForAction,
  patchOptionsForAction,
  otpPostOptions
};
